import Vue from 'vue';
import Router from 'vue-router';
import LoginView from '../views/login/Common';
import IndexView from '../views/Index'; 
import Skuinfo from '../views/order/orderPage/skuInfo';
import Orderinfo from '../views/order/orderPage/orderInfo';   
import exchangeRate from '../views/finance/exchangeRatePage/exchangeRate';
import freightMaintain from '../views/finance/freightMaintainPage/freightMaintain'; 
import grossProfit from '../views/finance/grossProfitPage/grossProfit';
import reimbursement from '../views/finance/reimbursementPage/reimbursement'; 
import cost from '../views/finance/costPage/cost';
import monthlyProfit from '../views/finance/monthlyProfitPage/monthlyProfit'; 
import restock from '../views/finance/restockPage/restock';
import adsGroups from '../views/finance/adsGroups/adsGroupsPage';
import userInfo from '../views/user/userInfo';

import { Button, Form, FormItem, Input, Message } from "element-ui";
// 全局Router异常处理
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    // return originalPush.call(this, location).catch(err => { if (typeof err !== 'undefined')console.log(err) })
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

/*路由配置*/
let constRouter = [
    {
        path: '/',
        name: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: '/login',
        component: LoginView
    },
    {
        path: '/index',
        name: '/index',
        component: IndexView,
        meta: { requireAuth: true },
        children: [
            {
                path: '/exchangeRate',
                component: exchangeRate,
                name:'/exchangeRate'
            },
            {
                path: '/freightMaintain',
                component: freightMaintain,
                name: '/freightMaintain'
            },
            {
                path: '/grossProfit',
                component: grossProfit,
                name:'/grossProfit'
            },
            {
                path: '/reimbursement',
                component: reimbursement,
                name: '/reimbursement'
            },
            {
                path: '/cost',
                component: cost,
                name:'/cost'
            },
            {
                path: '/monthlyProfit',
                component: monthlyProfit,
                name: '/monthlyProfit'
            },
            {
                path: '/sku',
                component: Skuinfo,
                name: '/sku'
            }, 
            {
                path: '/orderWrite',
                component: Orderinfo,
                name: '/orderWrite'
            },
            {
                path: '/restockPage',
                component: restock,
                name: '/restockPage'
            }, 
            {
                path: '/adsGroups',
                component: adsGroups,
                name: '/adsGroups'
            }, 
            {
                path: '/userInfo',
                component: userInfo,
                name: '/userInfo'
            }
        ]
    } 
]
/*创建路由实例，将路由配置放入路由实例中*/
let router = new Router({
    /*mode: 'history',*/
    routes: constRouter
})


const whiteList = ['/login']

let asyncRouter


export default router
